/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Faq_Q5Inputs */

const en_to_csv_faq_q5 = /** @type {(inputs: To_Csv_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are nested objects flattened into separate columns?`)
};

const ko_to_csv_faq_q5 = /** @type {(inputs: To_Csv_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`중첩 객체가 별도의 열로 펼쳐지나요?`)
};

const ja_to_csv_faq_q5 = /** @type {(inputs: To_Csv_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネストしたオブジェクトは別々の列に展開されますか`)
};

/**
* | output |
* | --- |
* | "Are nested objects flattened into separate columns?" |
*
* @param {To_Csv_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_faq_q5 = /** @type {((inputs?: To_Csv_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_faq_q5(inputs)
	if (locale === "ko") return ko_to_csv_faq_q5(inputs)
	return ja_to_csv_faq_q5(inputs)
});